function ErrorPage()
{

    return <> <h1> OOPS ..... PAGE NOT FOUND  </h1>  </>

}

export default ErrorPage;